import {
  Box,
  Card,
  Skeleton
} from "@mui/material";
const DummyPostCard: React.FC<{elevationValue?:number}> = ({elevationValue=1}) => {
  return (
    <Card className="w-full p-1 mt-4" elevation={elevationValue}>
      <Box className="pr-2 pl-2 pt-2 rounded-sm">
        <Box>
          <Skeleton variant="text" />
          <Skeleton variant="text" width="20%" />
        </Box>
      </Box>
      <Box className="p-2 pb-4">
        <Skeleton variant="rectangular" height={100} />
        <Box className="p-0 mt-2">
          <Skeleton variant="text" width="50%" />
        </Box>
        <Box className="p-0 mt-2 flex">
          {[1, 2, 3].map((tag) => (
            <Skeleton key={tag} variant="rounded" width={80} height={25}  sx={{mr:2,borderRadius:50}} />
          ))}
        </Box>
      </Box>
      <Box className="p-2">
        <Box className="flex justify-between items-center">
          <Box className="flex">
            <Skeleton
              animation="wave"
              variant="circular"
              width={40}
              height={40}
            />
            <Box className="pl-4 w-40">
              <Skeleton
                animation="wave"
                height={10}
                width="100%"
                style={{ marginBottom: 6 }}
              />
              <Skeleton
                animation="wave"
                height={10}
                width="60%"
                style={{ marginBottom: 6 }}
              />
            </Box>
          </Box>
          <Box className="pr-2">
            <Skeleton animation="wave" height={40} width={100} />
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default DummyPostCard;
